import { put, call, takeEvery, select, delay } from 'redux-saga/effects';
import axios from 'axios';
import {
  setMyWorkSapcesData,
  setWorkspaceOverviewData,
  setProgress,
  setWorkspaceChatData,
  setWorkspaceDocuments,
  setWorkspaceReports,
  setDialogDetails,
  setWorkspacePreviewDocument,
  setContentForCurrentSlideInReport
} from './workspacesSlice';
import { selectConversationCategory, setConversationsData } from '../conversations/conversationsSlice';

function* getWorkspaces(event) {
  let progress: any = true;
  try {
    const response = yield axios.get('/workspace/list', {
      ...event.payload
    });
    yield put(setMyWorkSapcesData(response.data));
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* getWorkspaceOverview(event) {
  let progress: any = true;
  try {
    const { workspaceId } = event.payload;
    const response = yield axios.get('/workspace/' + workspaceId, {
      ...event.payload
    });
    yield put(setWorkspaceOverviewData(response.data));
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* getWorkspaceChats(event) {
  let progress: any = true;
  const conversationCategory = yield select(selectConversationCategory);
  try {
    const { chatId } = event.payload;
    const categoryInclude = conversationCategory !== 'Generic' ? '' : 'chatType=free-chat';
    const response = yield axios.get('/chat/history/' + chatId + '?' + categoryInclude, {
      ...event.payload
    });
    yield put(setWorkspaceChatData(response.data));
    yield put(setConversationsData(response.data));
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* getWorkspaceDocuments(event) {
  let progress: any = true;
  try {
    const { workspaceId } = event.payload;
    const response = yield axios.get('/workspace/documents/' + workspaceId, {
      ...event.payload
    });
    yield put(setWorkspaceDocuments(response?.data?.data));
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* getWorkspaceReports(event) {
  let progress: any = true;
  try {
    const { workspaceId } = event.payload;
    const response = yield axios.get('/report/list/' + workspaceId, {
      ...event.payload
    });
    yield put(setWorkspaceReports(response?.data));
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* uploadVersionDocument(event) {
  let progress: any = true;
  const { file, documentType, documentId, workspaceId } = event.payload;
  try {
    let formData = new FormData();
    formData.append('documentId', documentId);
    formData.append('documentType', documentType);
    formData.append('file', file);

    yield put(setProgress(progress));

    yield call(axios.post, `/workspace/documents/version`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    yield call(getWorkspaceDocuments, { payload: { workspaceId } });
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* addNewReport(event) {
  let progress: any = true;
  const { file, workspaceId } = event.payload;
  try {
    let formData = new FormData();
    formData.append('workspaceId', workspaceId);
    formData.append('file', file);

    yield put(setProgress(progress));

    const response = yield call(axios.post, `/report/create`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if(response?.data) {
      const reportData: any  = response?.data ?? {}
      console.log("reportDatareportData", reportData);
      
      yield put(setWorkspacePreviewDocument(reportData));
      yield delay(3000)
      yield call(getWorkspaceReports, {
        payload: event.payload
      })
    }
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* getAddedReportDetails(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));
    const response = yield call(axios.get, `/report/details/${event.payload}`, );
    if(response?.data) {
      const reportData: any  = response?.data ?? {}
      yield put(setWorkspacePreviewDocument(reportData));
    }
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* downloadGeneratedReport(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));
    const response = yield call(axios.post, `/report/download`, {
      ...event.payload
    });
    if(response?.data) {
     window.open(response?.data.data, "_self"); 
    }
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* getContentForSlideInReport(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/report/getSlideContentBySlide`, {
      ...(event.payload ?? {})
    });
    yield put(setContentForCurrentSlideInReport(response?.data?.data));
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* getAIRecommendedContentForSlideInReport(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/report/getAIContent`, {
      ...(event.payload ?? {})
    });
    
    yield put(setContentForCurrentSlideInReport(response?.data?.data?.htmlContent ?? ""));
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* saveNewReport(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/report/save`, {
      ...(event.payload ?? {})
    });
    if(!response?.data?.data) {
      alert(response?.data?.message);
    } else {
      window.location.reload()
    }
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* editVersionDocument(event) {
  let progress: any = true;
  try {
    const { versionId, status, workspaceId } = event.payload;
    const response = yield axios.put(`/workspace/documents/${versionId}/active-status`, {
      status
    });
    yield call(getWorkspaceDocuments, { payload: { workspaceId } });
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* openWorkspaceDialog(event) {
  yield put(
    setDialogDetails({
      open: true,
      ...event.payload
    })
  );
}
function* closeWorkspaceDialog(event) {
  yield put(setDialogDetails(undefined));
}
function* clearReportDetails(event) {
  yield put(setWorkspacePreviewDocument(undefined));
  yield put(setContentForCurrentSlideInReport(undefined));
  yield put(setContentForCurrentSlideInReport(undefined));
}

export function* workspacesSaga() {
  yield takeEvery('GET_WORKSPACES', getWorkspaces);
  yield takeEvery('GET_WORKSPACE_OVERVIEW', getWorkspaceOverview);
  yield takeEvery('GET_WORKSPACE_CHATS', getWorkspaceChats);
  yield takeEvery('GET_WORKSPACE_DOCUMENTS', getWorkspaceDocuments);
  yield takeEvery('GET_WORKSPACE_REPORTS', getWorkspaceReports);
  yield takeEvery('GET_CONTENT_FOR_SLIDE_IN_REPORT', getContentForSlideInReport);
  yield takeEvery('GET_AI_RECOMMENDED_CONTENT_FOR_SLIDE_IN_REPORT', getAIRecommendedContentForSlideInReport);
  yield takeEvery('OPEN_WORKSPACE_DIALOG', openWorkspaceDialog);
  yield takeEvery('CLOSE_WORKSPACE_DIALOG', closeWorkspaceDialog);
  yield takeEvery('WORKSPACE_EDIT_VERSION_DOCUMENT', editVersionDocument);
  yield takeEvery('WORKSPACE_UPLOAD_VERSION_DOCUMENT', uploadVersionDocument);
  yield takeEvery('WORKSPACE_ADD_NEW_REPORT', addNewReport);
  yield takeEvery('WORKSPACE_ADDED_REPORT_DETAILS', getAddedReportDetails);
  yield takeEvery('WORKSPACE_SAVE_NEW_REPORT', saveNewReport);
  yield takeEvery('WORKSPACE_DOWNLOAD_GENERATED_REPORT', downloadGeneratedReport);
  yield takeEvery('WORKSPACE_CLEAR_REPORT_DETAILS', clearReportDetails);
}
